// 9fbef606107a605d69c0edbcd8029e5d
import logger from '@tcp/core/src/utils/loggerInstance';
import { call, put, takeLatest } from 'redux-saga/effects';
import emailSignupAbstractor from '@tcp/core/src/services/abstractors/common/EmailSmsSignup';
import SMS_SUBSCRIPTION_CONSTANTS from './SubscriptionSMS.constants';
import { statusSMSSubscription } from './SubscriptionSMS.action';

export function* SMSSubscription({ payload }) {
  try {
    const { component } = payload;
    const res = yield call(emailSignupAbstractor.subscribeSms, payload);
    yield put(statusSMSSubscription({ subscription: { ...res, component } }));
  } catch (error) {
    logger.error('Error in Subscription SMS saga', error);
  }
}

function* SMSSubscriptionSaga() {
  yield takeLatest(SMS_SUBSCRIPTION_CONSTANTS.SUBSCRIPTION_SMS_SUBMIT, SMSSubscription);
}

export default SMSSubscriptionSaga;
